import classnames from 'classnames';
import React, { CSSProperties } from 'react';

export type DotSeparatedLabelProps = {
    className?: string;
    classNameLabel?: string;
    classNamePrimaryLabel?: string;
    classNameDot?: string;
    multiline?: boolean;
    labels: (string | React.JSX.Element | null | undefined)[];
    style?: CSSProperties;
    parentElement?: 'span' | 'div';
};

function DotSeparatedLabel(props: DotSeparatedLabelProps): React.JSX.Element {
    const {
        className,
        style,
        classNameLabel,
        classNamePrimaryLabel,
        classNameDot,
        labels: labelProps,
        multiline = true
    } = props;
    const filteredLabels = labelProps.filter((label) => label !== undefined && label !== '' && label !== null);
    const ParentElement = props.parentElement === 'span' ? 'span' : 'div';
    return (
        <ParentElement
            className={classnames(className, 'items-center', multiline !== true ? '' : 'flex flex-wrap')}
            style={style}>
            {filteredLabels.map((label, index) => (
                <span
                    key={`label#${index}`}
                    className={classnames(
                        multiline !== true ? '' : 'inline-flex',
                        index === 0 && classNamePrimaryLabel ? classNamePrimaryLabel : classNameLabel
                    )}>
                    {label}
                    {index < filteredLabels.length - 1 && (
                        <span
                            className={classnames(
                                classNameDot,
                                'px-4 lg:px-6',
                                multiline !== true ? '' : 'inline-block'
                            )}>
                            ·
                        </span>
                    )}
                </span>
            ))}
        </ParentElement>
    );
}

export default DotSeparatedLabel;
